@if (visible()) {
  @if (locked()) {
    <span class="d-flex align-items-center" dataSelector="payment-methods-locked-banner">
      <aiwyn-icon name="lock" width="14" height="14" class="me-2"></aiwyn-icon>
      <span>Enter a valid email above to enter payment methods</span>
    </span>
  } @else {
    <span class="d-flex align-items-center" dataSelector="payment-methods-unlocked-banner">
      <aiwyn-icon name="check-circle" width="14" height="14" class="me-2"></aiwyn-icon>
      <span>Email verified — you can now select a payment method</span>
    </span>
  }
}
